var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 90,
    viewBox: "0 0 101 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.8 20H20.2V0H80.8V20ZM80.8 47.5C82.2308 47.5 83.431 47.02 84.4006 46.06C85.3702 45.1 85.8534 43.9133 85.85 42.5C85.85 41.0833 85.3652 39.8967 84.3956 38.94C83.426 37.9833 82.2275 37.5033 80.8 37.5C79.3692 37.5 78.1706 37.98 77.2044 38.94C76.2382 39.9 75.7534 41.0867 75.75 42.5C75.75 43.9167 76.2348 45.105 77.2044 46.065C78.174 47.025 79.3725 47.5033 80.8 47.5ZM70.7 80V60H30.3V80H70.7ZM80.8 90H20.2V70H0V40C0 35.75 1.47292 32.1883 4.41875 29.315C7.36458 26.4417 10.9417 25.0033 15.15 25H85.85C90.1425 25 93.7415 26.4383 96.6469 29.315C99.5523 32.1917 101.003 35.7533 101 40V70H80.8V90Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print.9f120ad8e8970a5c9fe1b5c8d8889773.svg";